import React, { useState, useEffect } from "react";
// Components
import Navbar from "../../components/Navbar";
import iconUser from "../../assets/user/account-circle.svg";
import RolesComponent from "../../components/RolesComponent";
import * as S from "./styles";

import { useHistory, useLocation } from "react-router-dom";

import { IoChevronUp } from "react-icons/io5";
import ButtonV2 from "../../components/Button-v2";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";

export default function RoleRegistration() {
  const history = useHistory();
  const params = useQuery();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={iconUser} />
            <div>
              <S.Title>Cadastro de papéis</S.Title>
              <S.Description>
                Tela para cadastrar papéis de usuários.
              </S.Description>
            </div>
          </S.BoxUser>
        </S.Header>
        <RolesComponent
          pageFilter={parseInt(params.get("page") || "0")}
          history={history}
        />
        <GoTopoButtonWrapper>
          <ButtonV2
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            height="32px"
            leftIcon={IoChevronUp}
          >
            Topo
          </ButtonV2>
        </GoTopoButtonWrapper>
      </S.Wrapper>
    </>
  );
}
